// Module
var code = "<div class=\"scrollContent\">\n    <input name=\"renameInput\" id=\"renameInput\" />\n    <span class=\"errorMessage\"></span>\n</div>\n<div data-type=\"horizontal\" data-role=\"controlgroup\">\n    <a id=\"renameButton\" href=\"#\" data-role=\"button\" data-i18n=\"common::done.title\"></a>\n</div>";
// Exports
module.exports = code;